<template>
  <div>
    <FlotoPageHeader use-divider :title="`${$tc('baseline')}`" />
    <FlotoCrudContainer
      ref="list"
      as-table
      prepend-new-item
      :scrollable="false"
      :fetch-fn="getSummaryBaselines"
      :delete-fn="deleteSummaryBaselines"
      :create-fn="addSummaryBaselines"
      :update-fn="updateSummaryBaselines"
      :columns="tableColumns"
    >
      <template v-if="!disabled" v-slot:add-controls="{ items, create }">
        <MRow class="mb-4" :gutter="0">
          <MCol :size="12" class="flex justify-end">
            <MButton
              variant="primary"
              :disabled="items.length > 0"
              @click="create"
            >
              {{ $t('add') }} {{ $tc('baseline') }}
            </MButton>
          </MCol>
        </MRow>
      </template>
      <template v-slot:form-header="{ item }">
        {{ $tc(item.id ? 'change' : 'add') }} {{ $tc('baseline') }}
      </template>
      <template v-slot:form-items="{ item }">
        <AddBaselineForm
          :resource="resource"
          :baseline-data="item"
          @selection-change="selectionChange"
        />
      </template>
      <template v-slot:form-actions="{ submit, cancel, item }">
        <MButton
          class="mx-1"
          :disabled="selectedItems.length === 0 || selectedItems.length > 1"
          @click="submit"
        >
          {{ $t(item.id ? 'update' : 'add') }}
        </MButton>
        <MButton variant="default" @click="cancel">
          {{ $t('cancel') }}
        </MButton>
      </template>
      <template v-slot:createdById="{ item }">
        <td class="text-ellipsis">
          <FlotoUserDrawer :user-id="item.createdById" disabled />
        </td>
      </template>
      <template v-slot:createdTime="{ item }">
        <td class="text-ellipsis">
          <span v-if="item.createdTime">
            {{ item.createdTime | datetime }}
          </span>
          <span v-else>---</span>
        </td>
      </template>
      <template v-slot:actions="{ item, remove, edit }">
        <td class="text-ellipsis">
          <div style="display: inline-flex">
            <BaselineListAttributeDrawer
              v-if="!disabled"
              :attributes="item.rules"
            />
            <MTooltip v-if="!disabled">
              <template v-slot:trigger>
                <MIcon
                  name="pencil"
                  class="mr-2 mt-1 cursor-pointer text-primary"
                  @click="edit"
                />
              </template>
              {{ $t('edit') }}
            </MTooltip>
            <FlotoDeleteBtn
              v-if="!disabled"
              :message="$t('confirm_delete_item', { item: $tc('baseline') })"
              @confirm="remove"
            />
          </div>
        </td>
      </template>
    </FlotoCrudContainer>
  </div>
</template>
<script>
import Bus from '@utils/emitter'
import {
  checkSummaryBaselineRelationExistApi,
  getSummaryBaselineApi,
  deleteSummaryBaselinesApi,
  createSummaryBaselinesApi,
  updateSummaryBaselinesApi,
} from '../../../asset-api'
import AddBaselineForm from './add-baseline-form'
import BaselineListAttributeDrawer from './baseline-list-attribute-drawer'
export default {
  name: 'BaselineList',
  components: { AddBaselineForm, BaselineListAttributeDrawer },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.tableColumns = [
      {
        name: `${this.$tc('id')}`,
        key: 'name',
        minWidth: '100px',
        width: '100px',
      },
      {
        name: `${this.$tc('name')}`,
        key: 'displayName',
      },
      {
        name: `${this.$tc('created_on')}`,
        key: 'createdTime',
      },
      {
        name: `${this.$tc('created_by')} `,
        key: 'createdById',
      },
      {
        name: `${this.$tc('action', 2)}`,
        key: 'actions',
        width: '120px',
      },
    ]
    return {
      selectedItems: [],
      baselineData: {},
    }
  },
  methods: {
    refresh() {
      this.$refs.list.refresh()
    },
    selectionChange(items) {
      this.selectedItems = items
    },
    checkExist() {
      return checkSummaryBaselineRelationExistApi(this.resourceId)
    },
    getSummaryBaselines(limit, offset) {
      return checkSummaryBaselineRelationExistApi(this.resourceId).then(
        (data) => {
          if (data === true) {
            return getSummaryBaselineApi(this.resourceId).then((baseline) => {
              this.baselineData = baseline.items
              Bus.$emit('asset:run-variance-detection', !!baseline.items.length)
              return baseline
            })
          } else {
            return Promise.resolve({ items: [], total: 0 })
          }
        }
      )
      // return getSummaryBaselineApi(this.resourceId).then((data) => {
      //   this.baselineData = data.items
      //   return data
      // })
    },
    deleteSummaryBaselines({ id }) {
      return deleteSummaryBaselinesApi(this.resourceId).then((data) => {
        this.refresh()
        this.$emit('refresh')
        Bus.$emit('asset:run-variance-detection', false)
        return data
      })
    },
    addSummaryBaselines(data) {
      const baselineId = this.selectedItems.map((i) => i.id)
      return createSummaryBaselinesApi(this.resourceId, baselineId).then(
        (data) => {
          this.refresh()
          this.$emit('refresh')
          return data
        }
      )
    },
    updateSummaryBaselines(data) {
      const baselineId = this.selectedItems.map((i) => i.id)
      return updateSummaryBaselinesApi(this.resourceId, baselineId).then(
        (data) => {
          this.refresh()
          this.$emit('refresh')
          return data
        }
      )
    },
  },
}
</script>
